import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';

interface CalendarMiniMonthProps {
  /** The calendar's current day: the same state the toolbar and the timeline use. */
  date: Date;
  onDateChange: (date: Date) => void;
}

/**
 * Standing month calendar next to (or under) the day view (#4121), so another
 * day is one click away without opening the toolbar's date popover. It is a
 * second view of the calendar's own date, not a copy: picking a day goes
 * through `onDateChange`, and the shown month follows `date` when the toolbar
 * steps or "today" moves it. Locale and week start come from the app-wide
 * LocalizationProvider.
 */
export function CalendarMiniMonth({ date, onDateChange }: CalendarMiniMonthProps) {
  const { t } = useTranslation('calendar');

  return (
    <Box
      component="aside"
      aria-label={t('miniCalendar')}
      data-testid="calendar-mini-month"
      sx={{
        flexShrink: 0,
        alignSelf: 'flex-start',
        width: 320,
        maxWidth: '100%',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      <DateCalendar
        value={date}
        onChange={(next) => {
          if (next) onDateChange(next);
        }}
      />
    </Box>
  );
}
